import toast from 'react-hot-toast'
import request from 'utils/request/requestBrc20'

/**
 * 获得费率
 * @returns 
 */
export const getFeeRate = async () => {
    try {
        const {code = -1, data = {}, msg=''}: any = await request.get('/getFeeRate')
        if(code === 0) {
            return data.rate
        }
        return '16'
    } catch(error) {
        throw error
    }
}



interface ApiSubmitOrderProps {
    certHash: string
    symbol: string // fromSymbol
    amount: string
    toChain: string
    toAddr: string
}
export const postSubmitOrder = async (params: ApiSubmitOrderProps, headers: {[key: string]: any}) => {
    try {
        const {code = -1, data = {}, msg=''}: any = await request.post('/submitOrder', params, {
            headers: headers
        })
    } catch(error) {
        throw error
    }
}